import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ShoppingBagIcon } from 'lucide-react';
import { offerAnchor, productName } from '../data/content';
import { recentPurchases } from '../data/purchases';
const FIRST_DELAY = 6000;
const VISIBLE_FOR = 5000;
const INTERVAL = 12000;
export function PurchasePopup() {
  const [index, setIndex] = useState<number | null>(null);
  useEffect(() => {
    let count = 0;
    let hideTimer: number | undefined;
    let interval: number | undefined;
    const show = () => {
      setIndex(count % recentPurchases.length);
      count += 1;
      hideTimer = window.setTimeout(() => setIndex(null), VISIBLE_FOR);
    };
    const first = window.setTimeout(() => {
      show();
      interval = window.setInterval(show, INTERVAL);
    }, FIRST_DELAY);
    return () => {
      window.clearTimeout(first);
      window.clearTimeout(hideTimer);
      window.clearInterval(interval);
    };
  }, []);
  const purchase = index === null ? null : recentPurchases[index];
  return <div aria-live="polite" className="pointer-events-none fixed bottom-3 left-3 z-[60] md:bottom-6 md:left-6" data-id="element-240" data-mp="164egi9kqbgk9">
      <AnimatePresence data-id="element-241" data-mp="114tl294rpqca">
        {purchase && <motion.a key={index} href={offerAnchor} initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto flex w-[270px] items-center gap-3 rounded-xl border-[3px] border-teal-800 bg-amber-400 p-3 shadow-2xl shadow-teal-950/50 ring-2 ring-white" data-id="element-242" data-mp="1fw24g0i2ufgz">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-teal-800" data-id="element-243" data-mp="s5yakkuoxu36">
              <ShoppingBagIcon className="h-5 w-5 text-white" aria-hidden="true" data-id="element-244" data-mp="28jeoo40rmb74" />
            </span>
            <span className="min-w-0 text-left" data-id="element-245" data-mp="23klcqg14ms92">
              <span className="block text-sm font-extrabold leading-tight text-teal-950" data-id="element-246" data-mp="2aol7cla0kq6y">
                {purchase.name}{' '}
                <span className="font-semibold" data-id="element-247" data-mp="2fmv2wwznhst3">
                  from {purchase.city}, {purchase.country}
                </span>
              </span>
              <span className="mt-0.5 block text-xs text-teal-950" data-id="element-248" data-mp="2kko6rjdheaq7">just purchased the {productName}</span>
              <span className="mt-0.5 block text-[10px] font-black uppercase tracking-wider text-teal-950/80" data-id="element-249" data-mp="2pjhm7hcbwbt0">
                {purchase.time}
              </span>
            </span>
          </motion.a>}
      </AnimatePresence>
    </div>;
}